import { useEffect, useRef, useState } from 'react';

const labelClass = 'mb-1.5 block text-sm font-medium text-slate-700';
const DEBOUNCE_MS = 500;

export default function DebouncedColorField({
  id,
  label,
  value,
  onChange,
  debounceMs = DEBOUNCE_MS,
}) {
  const [localValue, setLocalValue] = useState(value);
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    if (localValue === value) return undefined;

    const timer = window.setTimeout(() => {
      onChangeRef.current(localValue);
    }, debounceMs);

    return () => window.clearTimeout(timer);
  }, [localValue, value, debounceMs]);

  return (
    <div>
      <label htmlFor={id} className={labelClass}>
        {label}
      </label>
      <div className="flex items-center gap-3">
        <input
          id={id}
          type="color"
          value={localValue}
          onChange={(e) => setLocalValue(e.target.value)}
          className="h-10 w-14 cursor-pointer rounded-lg border border-slate-200 bg-white p-1"
        />
        <span className="font-mono text-sm text-slate-600">{localValue}</span>
      </div>
    </div>
  );
}
